import { useState, useCallback, useEffect } from "react";
import { Auth, useAuthedRequest } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export function useAwards() {
  const { makeAuthedRequest } = Auth.useContainer();

  const { logError } = useLogger({ prefix: "useAwards" });
  const [requestId, setRequestId] = useState(0);
  const [awards, setAwards] = useState(null);
  const [isWaiting, setIsWaiting] = useState(false);

  const { data, loading, error } = useAuthedRequest(
    `/v1/membership/loa/awards`
  );

  // Prevent records from becoming null between refreshes.
  useEffect(() => {
    if (data != null) {
      //update to receive actual data
      setAwards(data);
    }
  }, [data]);

  const refresh = useCallback(() => {
    setRequestId(requestId + 1);
  }, [requestId]);

  return {
    awards,
    loading,
    isWaiting,
    refresh,
  };
}
